/** @jsxImportSource @emotion/react */
import React from 'react';
import { t } from 'i18next';
import { SelectItem } from '../../../../shared/ModalSelectField';
import { ModalMultiSelectField } from '../../../../shared/ModalMultiSelectField';

interface AssessmentCountryMultiSelectFieldProps {
  options: string[];
  defaultValue?: string[];
  editable?: boolean;
  onUpdate?: (brand: string[]) => void;
}

export function AssessmentCountryMultiSelectField({
  options,
  defaultValue = [],
  editable = false,
  onUpdate,
}: AssessmentCountryMultiSelectFieldProps) {
  const toSelectItem = (item: string): SelectItem => {
    return {
      code: item,
      description: item,
    };
  };

  const toString = (item: SelectItem): string => {
    return item.code;
  };

  return (
    <ModalMultiSelectField
      icon='flag'
      defaultValue={defaultValue.map(toSelectItem) || []}
      list={options.map(toSelectItem)}
      title={t('assessment.archive.filters.countries') || ''}
      editable={editable}
      onUpdateValue={(selectedBrand: SelectItem[]) => {
        if (onUpdate) {
          onUpdate(selectedBrand.map(i => toString(i)));
        }
      }}
    />
  );
}
